export default [
    '$scope',
    function InfoMessageController() {
        return;
    }
];
